// extracted by mini-css-extract-plugin
export var collapsedSummary = "_nv-0";